export const openEditForm = id => ({
  type: 'OPEN_EDIT_FORM',
  id
})

export const closeEditForm = id => ({
  type: 'CLOSE_EDIT_FORM',
  id
})

export const removeCompanyUser = id => ({
  type: 'REMOVE_COMPANY_USER',
  id
})

export const updateCompanyUser = props => ({
  type: 'UPDATE_COMPANY_USER',
  props
})

export const setActiveTab = (tab, hasOpenForm) => ({
  type: 'SET_ACTIVE_TAB',
  hasOpenForm,
  tab
})

export const addUserInvitation = invitation => ({
  type: 'ADD_USER_INVITATION',
  invitation
})

export const updateInvitation = invitation => ({
  type: 'UPDATE_USER_INVITATION',
  invitation
})

export const removeInvitation = ({ id }) => ({
  type: 'DELETE_USER_INVITATION',
  id
})

export const openUserInvitationForm = () => ({
  type: 'OPEN_USER_INVITATION_FORM'
})

export const closeUserInvitationForm = () => ({
  type: 'CLOSE_USER_INVITATION_FORM'
})

export const deleteContact = ({ id }) => ({
  type: 'DELETE_CONTACT',
  id
})



// WEBPACK FOOTER //
// ./app/javascript/reactFeatures/company-users/actions/companyUsers.js